import { CssBaseline, ThemeProvider } from "@mui/material";
import { HelmetProvider } from "react-helmet-async";
// theme
import theme from "./theme";
import GlobalStyles from "./theme/globalStyles";
//
import Router from "./routes";
import { AppContextProvider } from "./contexts/AppContext";
import './authStyles.css';
import { SnackbarProvider } from "notistack";

function App() {

  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={5000}>
        <CssBaseline />
        <AppContextProvider>
          <HelmetProvider>
            <GlobalStyles />
            <Router />
          </HelmetProvider>
        </AppContextProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
